import { z } from 'zod';

export const LinearStatusSchema = z.object({
	status: z.enum(['connected', 'expired', 'not_connected']),
});
export type LinearStatus = z.infer<typeof LinearStatusSchema>;

export const LinearAuthorizeSchema = z.object({
	redirectUrl: z.string(),
});
export type LinearAuthorize = z.infer<typeof LinearAuthorizeSchema>;

export const LinearDisconnectSchema = z.object({
	disconnected: z.boolean(),
});
export type LinearDisconnect = z.infer<typeof LinearDisconnectSchema>;
